import React from 'react';

import IconType from '../../../types/Icon';

const ArrowRightIcon: React.FC<IconType> = ({ color = 'currentColor', size = 24 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path d="M9 18L15 12L9 6" stroke={color} strokeWidth="2" />
		</svg>
	);
};

export default ArrowRightIcon;
